// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_student,
  add_student,
  update_student,
  delete_student,
  get_student_list,
  get_bulk_student,
  get_promotion_student,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset();
  today.setMinutes(today.getMinutes() - offset);
  return today.toISOString().split("T")[0];
};
const initialState = {
  promotionstudent: [],
  students: [],
  studentlist: [],
  studentfilterlist: [],
  studentbulklist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  bulkloading:false,
  promotionloading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    session: "",
    admission_date: getTodayDate() || "",
    name: "",
    date_of_birth: "",
    pan_no: "",
    aadhar_no: "",
    age: "",
    gender: "",
    blood_group: "",
    mother_tongue: "",
    nationality: "",
    religion: "",
    caste: "",
    category: "",
    school_class: "",
    mobile_no: "",
    email: "",
    house_no: "",
    street: "",
    area: "",
    P_O: "",
    distt: "",
    city: "",
    state: "",
    pin: "",
    address:"",

    father_name: "",
    father_academic_qualification: "",
    father_occupation: "",
    father_designation: "",
    father_office_phone_no: "",
    father_work_detail: "",
    father_annual_income: "",
    father_phone: "",
    mother_name: "",
    mother_academic_qualification: "",
    mother_occupation: "",
    mother_designation: "",
    mother_office_phone_no: "",
    mother_work_detail: "",
    mother_annual_income: "",
    mother_phone: "",
    guardian_name: "",
    guardian_academic_qualification: "",
    guardian_occupation: "",
    guardian_designation: "",
    guardian_relation: "",
    guardian_phone: "",
    previous_school_name_address: "",
    previous_school_class: "",
    previous_school_session: "",
    previous_school_board: "",
    previous_school_medium: "",
    at_school: "",
    distance_from_home: "",
    father_photo: "",
    mother_photo: "",
    guardian_photo: "",
    student_photo: "",
    photocopy_marksheet: "",
    dob_certificate: "",
    photocopy_tc: "",
    photocopy_health_report: "",
    counsellor:""

  },
};


// Async Thunks for API Calls
export const fetchStudentList = createAsyncThunk(
  "student/fetchStudentList",
  async (
    { school_id, class_id, section_id, token,search, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_student_list(
        school_id,
        class_id,
        section_id,
        token,
        search,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const fetchfilterStudentList = createAsyncThunk(
  "student/fetchfilterStudentList",
  async (
    { school_id, class_id, section_id, token,search, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_student_list(
        school_id,
        class_id,
        section_id,
        token,
        search,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const fetchBulkStudentList = createAsyncThunk(
  "student/fetchBulkStudentList",
  async (
    {
      school_id,
      club_id,
      class_id,
      session_id,
      section_id,
      dormitory_id,
      dormitoryroom_id,
      category,
      house_id,
      student_category_id,
      search,
      token,
      signal,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_bulk_student(
    
        school_id,
        club_id,
        class_id,
        session_id,
        section_id,
        dormitory_id,
        dormitoryroom_id,
        category,
        house_id,
        student_category_id,
        search,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



// Async Thunks for API Calls
export const fetchPromtionstudent = createAsyncThunk(
  "student/fetchPromtionstudent",
  async (
    { class_id, section_id, session_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_promotion_student(
        class_id,
        section_id,
        session_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls


export const fetchstudent = createAsyncThunk(
  "student/fetchstudent",
  async (
    { page, page_size, school_id,search,filter_fields, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_student(
        page,
        page_size,
        school_id,
        search,
        filter_fields,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const createstudent = createAsyncThunk(
  "student/createstudent",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_student(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatestudent = createAsyncThunk(
  "student/updatestudent",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_student(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletestudent = createAsyncThunk(
  "student/deletestudent",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_student({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        session: "",
        admission_date: getTodayDate() || "",
        name: "",
        date_of_birth: "",
        pan_no: "",
        aadhar_no: "",
        age: "",
        gender: "",
        blood_group: "",
        mother_tongue: "",
        nationality: "",
        religion: "",
        caste: "",
        category: "",
        school_class: "",
        mobile_no: "",
        email: "",
        house_no: "",
        street: "",
        area: "",
        P_O: "",
        distt: "",
        city: "",
        state: "",
        pin: "",
        address:"",
        father_name: "",
        father_academic_qualification: "",
        father_occupation: "",
        father_designation: "",
        father_office_phone_no: "",
        father_work_detail: "",
        father_annual_income: "",
        father_phone: "",
        mother_name: "",
        mother_academic_qualification: "",
        mother_occupation: "",
        mother_designation: "",
        mother_office_phone_no: "",
        mother_work_detail: "",
        mother_annual_income: "",
        mother_phone: "",
        guardian_name: "",
        guardian_academic_qualification: "",
        guardian_occupation: "",
        guardian_designation: "",
        guardian_relation: "",
        guardian_phone: "",
        previous_school_name_address: "",
        previous_school_class: "",
        previous_school_session: "",
        previous_school_board: "",
        previous_school_medium: "",
        at_school: "",
        distance_from_home: "",
        father_photo: false,
        mother_photo: false,
        guardian_photo: false,
        student_photo: false,
        photocopy_marksheet: false,
        photocopy_tc: "",
        dob_certificate: "",
        photocopy_health_report: false,
    counsellor:""

      };
    },
    setStudent(state, action) {
      state.students = action.payload;
    },
    setStudentBulkList(state, action) {
      state.studentbulklist = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
      .addCase(fetchStudentList.fulfilled, (state, action) => {
        state.studentlist = action.payload.data;
      })
      .addCase(fetchStudentList.rejected, (state, action) => {
        state.studentlist = [];
      })
      .addCase(fetchfilterStudentList.fulfilled, (state, action) => {
        state.studentfilterlist = action.payload.data;
      })
      .addCase(fetchfilterStudentList.rejected, (state, action) => {
        state.studentfilterlist = [];
      })
      // Fetch Classes
      .addCase(fetchPromtionstudent.pending, (state) => {
        state.promotionloading = true;
      })
      .addCase(fetchPromtionstudent.fulfilled, (state, action) => {
        state.promotionloading = false;
        state.promotionstudent = action.payload;
      })
      .addCase(fetchPromtionstudent.rejected, (state, action) => {
        state.promotionloading = false;
        state.promotionstudent = [];
      })
      // Fetch Classes
      .addCase(fetchBulkStudentList.pending, (state) => {
        state.bulkloading = true;
      })
      .addCase(fetchBulkStudentList.fulfilled, (state, action) => {
        state.studentbulklist = action.payload;
        state.bulkloading = false;

      })
      .addCase(fetchBulkStudentList.rejected, (state, action) => {
        state.bulkloading = false;
        state.studentbulklist = [];
      })
      // Fetch Classes
      .addCase(fetchstudent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchstudent.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchstudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createstudent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createstudent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createstudent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatestudent.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatestudent.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatestudent.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletestudent.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletestudent.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletestudent.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setStudent,
  setStudentBulkList,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setSchoolId,
} = studentSlice.actions;
export default studentSlice.reducer;
